module.exports = __webpack_public_path__ + "static/media/bird.9d3234a4.svg";